import { Box, HStack, Icon, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import { FiClock, FiMonitor, FiRadio } from 'react-icons/fi'
import { CoreProgramsDisplayProps } from '../utils/types'

const formatHours = (hours: number) => `${hours} hours`

export const CoreProgramsDisplay = ({
  coreProgramsCounts,
}: CoreProgramsDisplayProps) => {
  const liveHours = coreProgramsCounts.live || 0
  const recordingHours = coreProgramsCounts.recording || 0
  const totalHours = liveHours + recordingHours

  return (
    <Box
      aria-label='Your Core Program hours this month'
      background='gray.50'
      borderColor='gray.200'
      borderRadius='xl'
      borderWidth='1px'
      p={{ base: 4, md: 6 }}
    >
      <Stack spacing={4}>
        <Text fontWeight='semibold'>Your Core Program hours this month</Text>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
          <HoursSummary icon={FiRadio} label='Live sessions' value={liveHours} />
          <HoursSummary icon={FiMonitor} label='Recordings watched' value={recordingHours} />
          <HoursSummary icon={FiClock} label='Total' value={totalHours} isTotal />
        </SimpleGrid>
      </Stack>
    </Box>
  )
}

const HoursSummary = ({
  icon,
  label,
  value,
  isTotal = false,
}: {
  icon: typeof FiClock
  label: string
  value: number
  isTotal?: boolean
}) => (
  <HStack
    borderColor='gray.200'
    borderLeftWidth={{ base: 0, md: '1px' }}
    _first={{ borderLeftWidth: 0 }}
    pl={{ base: 0, md: 4 }}
    spacing={3}
  >
    <Box
      background={isTotal ? 'green.100' : 'purple.100'}
      borderRadius='lg'
      color={isTotal ? 'green.700' : 'purple.600'}
      p={3}
    >
      <Icon as={icon} aria-hidden boxSize={7} />
    </Box>
    <Stack spacing={0}>
      <Text>{label}</Text>
      <Text color={isTotal ? 'green.700' : undefined} fontSize='xl' fontWeight='bold'>
        {formatHours(value)}
      </Text>
    </Stack>
  </HStack>
)
